import styled from "styled-components";

import Image from "react-bootstrap/Image";

export const CastImg = styled(Image)`
    border-radius: 30px;
`;
